import 'moment/locale/es';
import moment from "moment";


export default (() => {
    const mom = moment;
    mom.locale('es');
    return mom;
})()